export const INIT_POS = { x: 80, y: -16 };

export const MAX_HEIGHT = 'calc(100vh - 64px - 64px)';
export const MIN_HEIGHT = '182px';
